module.exports = __webpack_public_path__ + "img/fashion_26.14f27b9f.jpg";